import React, { useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import maybeFormatDate from './maybeFormatDate';

const PieChart = ({ data, colours, chartHeight = 300, inputType = null }) => {
    const ref = useRef(null);

    const chartData = data.map(e => {
        const { str } = maybeFormatDate(e.name, inputType);

        return {
            ...e,
            name: str
        };
    });

    const options = {
        tooltip: {
            trigger: 'item',
            formatter: params => `${params.marker}${params.name}: <b>${params.value}</b>`
        },
        color: colours,
        legend: {
            show: false
        },
        series: [
            {
                type: 'pie',
                radius: ['40%', '70%'],
                data: chartData,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };

    const height = Boolean(chartHeight >= 300) ? chartHeight : 300;

    return (
        <ReactECharts
            option={options}
            style={{ height }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default PieChart;
